// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2756":"7ea29584","8942":"7ea29584"}[chunkId] + ".chunk.css";
};